import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApolloBaseApiService } from '../../../../core/services/graph-ql';
import { JOBS_V2_NAME_NO_OVERLAY } from '../../../../graphql.module';
import { JobVariations, JobVariationsResult, JobVariationsVariables } from './domain/api/queries/GetJobVariations.generated';

export type JobVariation = NonNullable<NonNullable<JobVariationsResult['jobVariations']>['items']>[number];

@Injectable({ providedIn: 'root' })
export class JobVariationsV2Service extends ApolloBaseApiService {
    constructor(apollo: Apollo) {
        super(apollo, JOBS_V2_NAME_NO_OVERLAY);
    }

    getVariations(variables: JobVariationsVariables) {
        return this.graphqlGateway.query({
            query: JobVariations,
            variables,
            fetchPolicy: 'no-cache',
        });
    }
}
